import comp from "./AssessmentToolModal";
export default comp;
